import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error(t("Passwords don't match"));
      return;
    }
    setBusy(true);
    try {
      const r = await api.post("/auth/reset-password", { token, password });
      toast.success(r.data.message);
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#fafcfa]">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md bg-white rounded-lg border border-[#e2ebe4] p-8" data-testid="reset-password-page">
          <ShieldCheck className="w-8 h-8 text-[#009900] mb-3" />
          <h1 className="heading-upper text-xl text-[#144733]">{t("Choose a new password.")}</h1>
          {!token ? (
            <p className="text-sm text-[#57685e] mt-4" data-testid="reset-no-token">{t("This link is missing its token.")} <Link to="/forgot-password" className="text-[#009900] underline">{t("Request a new reset link")}</Link>.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="field-label">{t("New password (min 8 characters)")}</label>
                <input type="password" required minLength={8} className="field-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
              </div>
              <div>
                <label className="field-label">{t("Confirm new password")}</label>
                <input type="password" required className="field-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
              </div>
              <button type="submit" disabled={busy} className="btn-cta rounded w-full py-3 text-xs flex items-center justify-center gap-2 disabled:opacity-50" data-testid="reset-submit-btn">
                {busy && <Loader2 className="w-4 h-4 animate-spin" />} {t("Update password")}
              </button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
